/* Persist first-touch acquisition to acquisition/{uid}.
 *
 * Same shape and reasoning as proInterest.js: one flat top-level doc per user,
 * client-writable, browsable in the Firestore console. This app writes no
 * users/{uid} document at signup — signup time lives only in Firebase Auth —
 * so there is no existing doc to hang the field on.
 *
 * First-touch is enforced by reading before writing rather than by merging. A
 * merge would quietly update `source` on every return visit and turn this into
 * last-touch attribution, which at five users would erase the original answer
 * the first time somebody came back via a bookmark.
 *
 * Best-effort throughout: a failure here must never interfere with signing in.
 */
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./firebase.js";
import { readAttribution } from "./attribution.js";

export async function saveAcquisition(uid) {
  if (!db || !uid) return;
  try {
    const attribution = readAttribution();
    if (!attribution) return;

    const ref = doc(db, "acquisition", uid);
    const snap = await getDoc(ref);
    /* Already recorded — leave the original source alone. */
    if (snap.exists()) return;

    await setDoc(ref, { uid, ...attribution });
  } catch (e) {
    console.warn("acquisition write failed:", e?.code || e?.message);
  }
}
